<template>
  <div id="app">
    <router-view></router-view>
    <ChatWindow  />
  </div>
</template>

<script>
import ChatWindow from '@/components/chatWindow.vue'
export default {
  name: 'App',
  components: {
    ChatWindow
  }
}
</script>

